import React from "react";
import { useTranslation } from "react-i18next";
import "./SessionTimeoutModal.css";

export default function SessionTimeoutModal({
  open,
  secondsLeft,
  onExtend,
  onLogout,
  busy,
  extendByMs,
}) {
  const { t } = useTranslation();

  if (!open) return null;

  const pretty = (s) => {
    if (typeof s !== "number") return "";
    const mm = String(Math.floor(s / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  return (
    <div
      className="session-timeout-backdrop"
      onClick={(e) => e.target === e.currentTarget && onLogout()}
    >
      <div className="session-timeout-modal">
        <div className="session-timeout-top">
          <div className="session-timeout-main-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v6l4 2" />
            </svg>
          </div>

          <div>
            <h2>{t("session_timeout_title")}</h2>
            <p>{t("session_timeout_description")}</p>
          </div>
        </div>

        <div className="session-timeout-line" />

        <div className="session-timeout-time-row">
          <div className="session-timeout-small-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v6l4 2" />
            </svg>
          </div>

          <span>{t("session_timeout_remaining")}</span>

          <strong>{pretty(secondsLeft)}</strong>
        </div>

        <div className="session-timeout-line" />

        <div className="session-timeout-actions">
          <button
            type="button"
            onClick={onLogout}
            disabled={busy}
            className="session-timeout-btn session-timeout-btn-logout"
          >
            {t("logout")}
          </button>

          <button
            type="button"
            onClick={onExtend}
            disabled={busy}
            className="session-timeout-btn session-timeout-btn-extend"
          >
            {busy
              ? t("session_timeout_extending")
              : t("session_timeout_extend", {
                  minutes: Math.round(extendByMs / 60000),
                })}
          </button>
        </div>
      </div>
    </div>
  );
}